// passwordMeter behaviour — the password visibility toggle (eye-icon swap).
//
// Reads hm from the shared context (set by hiveMind.adopt on the assembled
// behaviors object, mirrored into context — see behaviors/context.js).

import context from './context.js';

const passwordMeter = {
    create: function (el) {
        const hm = context.hm;

        // The primary password field inside the widget host.
        const input = el.querySelector('input[type="password"], input[type="text"]');
        // The visibility control holding the two eye icons.
        const control = el.querySelector('[data-zit-password-meter-control="visibility"]');

        if (input && control) {
            // The theme class the template uses to hide the inactive eye icon.
            const hiddenClass = hm.app.cssClass('displayNone');
            const icons = control.querySelectorAll('i');

            control.addEventListener('click', () => {
                // Flip the field between masked and revealed.
                input.type = input.type === 'password' ? 'text' : 'password';
                // Swap which eye icon shows by toggling the hide class on both.
                icons.forEach((icon) => {
                    hiddenClass.split(' ').forEach((cls) => {
                        if (cls) {
                            icon.classList.toggle(cls);
                        }
                    });
                });
            });
        }

        // Strength-meter highlighting (data-zit-password-meter-control="highlight")
        // is not wired yet — login uses showStrength=false. Add it here when a
        // page enables the strength bar.

        // No teardown needed: the listeners die with the markup.
        return { dispose: function () {} };
    }
};

export default passwordMeter;
